module.exports = __webpack_public_path__ + "static/hero-consulting-1413f7436bec8b4dd9980a1c99646ddc.svg";